import { render, staticRenderFns } from "./skishowdirector.vue?vue&type=template&id=23cac976&scoped=true"
import script from "./skishowdirector.vue?vue&type=script&lang=js"
export * from "./skishowdirector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cac976",
  null
  
)

export default component.exports